import useMutation from "src/hooks/useMutation";

function useOrderCheckReturnCreate(id) {
  return useMutation({
    path: `/api/v1/orders/${id}/process-return`,
    method: "POST",
    mutateRelatedDataList: {
      mutatePath: `/api/v1/orders/${id}`,
      shouldRevalidate: true,
    },
  });
}

export default useOrderCheckReturnCreate;
